<template>
    <Teleport to="body">
        <Transition name="fade">
            <div v-if="open" class="fixed inset-0 z-[9999] flex items-center justify-center">
                <!-- overlay -->
                <div class="absolute inset-0 bg-black/40" @click="onCancel" />

                <!-- dialog -->
                <div class="relative w-[92vw] max-w-md rounded-2xl bg-white shadow-2xl p-5" role="dialog"
                    aria-modal="true">
                    <div class="flex items-start justify-between gap-3">
                        <div>
                            <h3 class="text-lg font-semibold text-gray-900">
                                {{ title }}
                            </h3>
                            <p v-if="message" class="mt-2 text-sm text-gray-600 whitespace-pre-line">
                                {{ message }}
                            </p>
                        </div>

                        <button class="rounded-lg px-2 py-2 text-gray-500 hover:bg-gray-100" @click="onCancel"
                            aria-label="Close">
                            <i class="pi pi-times"></i>
                        </button>
                    </div>

                    <div class="mt-5 flex gap-2 justify-end">
                        <button :data-cy="cancelDataCy" class="px-4 py-2 rounded-xl border border-gray-200 hover:bg-gray-50" @click="onCancel">
                            {{ cancelText }}
                        </button>

                        <button :data-cy="confirmDataCy" :class="[
                            'px-4 py-2 rounded-xl text-white',
                            confirmVariant === 'danger' ? 'bg-rose-700 hover:bg-rose-800' : 'bg-gray-900 hover:bg-black'
                        ]" @click="onConfirm">
                            {{ confirmText }}
                        </button>
                    </div>
                </div>
            </div>
        </Transition>
    </Teleport>
</template>

<script setup>
const props = defineProps({
    open: {
        type: Boolean,
        default: false
    },
    title: {
        type: String,
        default: "Confirmare"
    },
    message: {
        type: String,
        default: ""
    },
    confirmText: {
        type: String,
        default: "Confirm"
    },
    cancelText: {
        type: String,
        default: "Renunță"
    },
    confirmVariant: {
        type: String,
        default: "danger"
    },
    confirmDataCy: { 
        type: String, 
        default: 'confirm-button' 
    },
    cancelDataCy: { 
        type: String, 
        default: 'cancel-button' 
    },
});

const emit = defineEmits(["confirm", "cancel", "update:open"]);

const onCancel = () => {
    emit("update:open", false);
    emit("cancel");
};

const onConfirm = () => {
    emit("update:open", false);
    emit("confirm");
};
</script>